import { render, staticRenderFns } from "./TableAgGrid.vue?vue&type=template&id=f984cdd0"
import script from "./TableAgGrid.vue?vue&type=script&lang=js"
export * from "./TableAgGrid.vue?vue&type=script&lang=js"
import style0 from "./TableAgGrid.vue?vue&type=style&index=0&id=f984cdd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports